import { call, put, takeLatest } from 'redux-saga/effects';

import * as coursesActions from './coursesActions.js';
import { updateCoursesApiCall } from './coursesAPI.js';

function* updateCoursesSaga({ payload }) {
  try {
    const { data } = yield call(updateCoursesApiCall, payload);
    yield put(coursesActions.coursesUpdateStore(data));
  } catch (error) {
    yield put(coursesActions.coursesUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* coursesWatcher() {
  yield takeLatest(coursesActions.coursesUpdateRequest.type, updateCoursesSaga);
}
